import { constants } from "@newsela/angelou";

const grey500 = constants.colors.ui.neutral[500];

export const bannerCss = {
  display: "flex",
  borderRadius: "8px",
  marginTop: "24px",
  marginBottom: "16px",

  "& > div > svg": {
    display: "none",
  },
};

export const panelContentCss = {
  color: grey500,
  wordWrap: "break-word" as const,
  height: "110px",
  overflowY: "auto" as const,
};
